module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick@2x-d502dcf7a93361674f95949be12de10e.png";